import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { UserTable } from "./UserTable";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  fetchId,
  selectLoading,
  fetchRole,
  selectRole,
  selectDataId,
  editItem,
  addOfficeUser,
  selectDataIdUser,
  fetchIdUser,
  editEmployee,
  removeUserOffice,
  unlockUserUpdate,
  resetUserUpdate,
  selectRoleModal,
  fetchRoleModal,
  editOfficeUser,
} from "./userSlice";
import {
  formLabelsTheme,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { addItem } from "./userSlice";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import {
  FormControlLabel,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));
function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const UserView = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectDataId);
  const dataOffice = useSelector(selectOffice);
  const dataUser = useSelector(selectDataIdUser);
  const { id } = useParams();

  const [tableDataUserOffice, setTableDataUserOffice] = useState([]);

  const [username, setUsername] = useState("");
  const [emp_id, setEmp_id] = useState("");
  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [designation, setDesignation] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [country_id, setCountry_id] = useState("");
  const [province, setProvince] = useState("");
  const [cp_first_name, setCp_first_name] = useState("");
  const [cp_last_name, setCp_last_name] = useState("");
  const [cp_email, setCp_email] = useState("");
  const [contactpersons, setContactpersons] = useState([]);
  const [list, setList] = useState(null);

  const [formUser, setFormUser] = useState({
    username: {
      value: "",
      error: false,
      required: "Y",
    },
  });
  const [fields, setFields] = useState([
    {
      cp_id: "",
      emp_id: "",
      phone_type: "",
      phone: "",
    },
  ]);

  useEffect(() => {
    async function fetchMyAPI() {
      await callApi(id);
    }
    fetchMyAPI();
  }, [dispatch, id]);

  useEffect(() => {
    if (dataId !== null) {
      setEmp_id(dataId.emp_id);
      setFirst_name(dataId.first_name);
      setLast_name(dataId.last_name);
      setDesignation(dataId.designation);
      setAddress1(dataId.address1);
      setAddress2(dataId.address2);
      setCity(dataId.city);
      setZipcode(dataId.zipcode);
      setCountry_id(dataId.country_id);
      setProvince(dataId.province);
      setCp_first_name(dataId.cp_first_name);
      setCp_last_name(dataId.cp_last_name);
      setCp_email(dataId.cp_email);
      setUsername(dataId.username);

      const initData =
        dataId.contactpersons === null
          ? [
              {
                cp_id: "",
                emp_id: dataId.emp_id,
                phone_type: "",
                phone: "",
              },
            ]
          : dataId.contactpersons.map((item, index) => {
              return {
                cp_id: item.cp_id,
                emp_id: item.emp_id,
                phone_type: item.phone_type,
                phone: item.phone,
              };
            });
      setFields(initData);

      setFormValues({
        emp_id: {
          value: dataId.emp_id,
          error: false,
        },
        first_name: {
          value: dataId.first_name,
          error: false,
        },
        address1: {
          value: dataId.address1,
          error: false,
        },
      });

      if (dataId.username !== null) {
        callApiUser(dataId.username);
      }
    }
  }, [dataId]);

  useEffect(() => {
    if (dataUser !== null) {
      const initData = dataUser.userOffices.map((item, index) => {
        return {
          ...item,
          no: index + 1,
          role_name:
            item.roles === null
              ? ""
              : item.roles.map((item) => item.role_description).join(","),
        };
      });
      setTableDataUserOffice(initData);
    }
  }, [dataUser]);

  const callApi = async (id) => {
    try {
      const response = await dispatch(fetchId(id));
      if (response.payload.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const callApiUser = async (id) => {
    try {
      const response = await dispatch(fetchIdUser(id));
      if (response.payload.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const [formValues, setFormValues] = useState({
    emp_id: {
      value: "",
      error: false,
      errorMessage: "This field is required",
    },
    first_name: {
      value: "",
      error: false,
      errorMessage: "This field is required",
    },
    address1: {
      value: "",
      error: false,
      errorMessage: "This field is required",
    },
  });

  // New
  const columns = [
    {
      text: "No",
      dataField: "no",

      style: { minWidth: "60px" },
      headerAlign: "center",
      hidden: true,
    },
    {
      text: "Office Code",
      dataField: "office_code",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Office Name",
      dataField: "office_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Roles",
      dataField: "role_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
  ];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    dataId && dataUser && (
      <>
        <Card>
          <CardHeader>
            <CardHeaderTitle className="card-title text-white ">
              User Profile : {dataId.username}
            </CardHeaderTitle>
          </CardHeader>

          <CardBody>
            <ThemeProvider theme={formLabelsTheme}>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    required
                    label="Employee ID"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="emp_id"
                    value={dataId.emp_id}
                  />
                  <RedditTextField
                    label="Job Role"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="designation"
                    value={dataId.designation}
                  />
                  <RedditTextField
                    inputProps={{ maxLength: 512 }}
                    required
                    label="Address Line 1"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    multiline
                    rows="4"
                    name="address1"
                    value={dataId.address1}
                  />
                  <RedditTextField
                    label="City"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="city"
                    value={dataId.city}
                  />
                  <RedditTextField
                    label="Province"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="province"
                    value={dataId.province}
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  {" "}
                  <RedditTextField
                    required
                    label="First Name"
                    inputProps={{ maxLength: 128 }}
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="first_name"
                    value={dataId.first_name}
                  />
                  <RedditTextField
                    label="Last Name"
                    inputProps={{ maxLength: 128 }}
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="last_name"
                    value={dataId.last_name}
                  />
                  <RedditTextField
                    label="Address Line 2"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    multiline
                    rows="4"
                    name="address2"
                    value={dataId.address2}
                  />
                  <RedditTextField
                    label="Zipcode"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="zipcode"
                    value={dataId.zipcode}
                  />
                  <RedditTextField
                    label="Country"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="Country"
                    value={dataId.country_name}
                  />
                </Col>
              </Row>
              <p className="font-weight-bold  m-3">Contact Details :</p>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  {fields.map((field, idx) => {
                    return (
                      <div key={`${field}-${idx}`}>
                        <Row>
                          <Col md={4}>
                            <RedditTextField
                              label="Type"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="number"
                              size="small"
                              fullWidth
                              value={field.phone_type || ""}
                            />
                          </Col>
                          <Col md={6}>
                            <RedditTextField
                              label="Phone Number"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="number"
                              size="small"
                              fullWidth
                              value={field.phone || ""}
                            />
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
                </Col>

                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="Email"
                    inputProps={{ maxLength: 128 }}
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="email"
                    value={dataId.email}
                  />
                </Col>
              </Row>
              <p className="font-weight-bold  m-3">
                Account Identity Information
              </p>

              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    required
                    label="User Login ID"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    value={dataUser.username}
                  />
                  <RedditTextField
                    required
                    label="Activity Status"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    value={dataUser.status_online}
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    required
                    label="Data Status"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    value={dataUser.status_enable}
                  />
                  <RedditTextField
                    required
                    label="Locked Status"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    value={dataUser.status_locked}
                  />
                </Col>
              </Row>
            </ThemeProvider>
            <p className="font-weight-bold  m-3">Offices</p>
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden rounded"
              bootstrap4
              
              keyField="No"
              data={dataUser === null ? [] : tableDataUserOffice}
              columns={columns}
              // sort={{ dataField: sortField, order: sortOrder }}
              hover
              striped
              headerClasses="header-class"
            />
          </CardBody>
        </Card>
      </>
    )
  );
};
